import { CustomContainer } from "../../components/CustomContainer/CustomContainer";
import { Stack } from "@mui/material";
import "./Up.scss";

function Up() {
    return (
        <CustomContainer>
            <Stack width={"100%"} mt={0}>
                <div className="up-message">
                    <p>Everything works !</p>
                </div>
            </Stack>
        </CustomContainer>
    )
}

export default Up;